export default __webpack_public_path__ + "static/media/nube.e0a922c9.svg";